module.exports = __webpack_public_path__ + "static/media/16UNODC24.a4e2072c.jpg";